'use client';
import styled from 'styled-components';
import Link from 'next/link';
import { theme } from '@/components/features/theme/theme';
import ReactHtmlParser from 'react-html-parser';
import { ImgParallax } from '@/components/common/ui/images/ImgParallax';
import { Img } from '@/components/common/ui/images/Img';
import { CURSOR_TEXT, DispatchCursor } from 'haspr-cursor';
import reactHtmlParser from 'react-html-parser';

const CaseStudySingle = ({ title, link, subject, img, color , noPara, subColor, hover, description, hoverText }) => {
	const dispatch = DispatchCursor()

	return (
		<StyledCaseStudySingle color={color} subColor={subColor} hover={hover} className="case-study-single " onMouseEnter={() => CURSOR_TEXT(dispatch, hoverText ? hoverText : 'View Case Study')} onMouseLeave={() => CURSOR_TEXT(dispatch, 'END')}>
			<div className="case-study-single__inner">
				{
					link &&
					<Link prefetch={true} href={link || '/blog/slug'}></Link>

				}
				<div className="global-image-image">
					{
						noPara ?
							<Img parallax src={img} alt={typeof title === 'string' ? title.replace(/<[^>]*>/g, '') : ''} />

							:
							<ImgParallax parallax src={img} alt={typeof title === 'string' ? title.replace(/<[^>]*>/g, '') : ''} />


					}
				</div>
				<div className="case-study-single__inner__count">
					<p className={'small-text '}>
						<span><svg width="32" height="2" viewBox="0 0 32 2" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.00195 1.00049H31.002" stroke="#152637" strokeOpacity="0.5" strokeLinecap="round" />
</svg>
</span>
						{subject}</p>
				</div>
				<div className="case-study-single__inner__content">
					<h6 className={''}>{title}</h6>
					{
						description &&
						reactHtmlParser(description)
					}
				</div>

			</div>
		</StyledCaseStudySingle>
	);
};

const StyledCaseStudySingle = styled.div`
    //width: 100%;

    .case-study-single__inner {
        position: relative;
        overflow: hidden;
        cursor: pointer;
        border-radius: 5px;

        .small-text {
            font-weight: 500;
            font-size: 1rem; /* 16px */
            line-height: 1.5rem; /* 24px */
            letter-spacing: 0;
            color: ${props => props.subColor || 'rgba(21, 38, 55, 0.5)' } ;
        }

        .global-image-image {
            transition: ${theme.transition};

            border-radius: 5px;
            overflow: hidden;

            .global-image {
                position: relative;
                height: auto;
            }

            img {
                transition: ${theme.transition};
                width: 100% !important;
                position: relative !important;
                height: auto !important;
            }
        }

        a {
            position: absolute;
            height: 100%;
            width: 100%;
            left: 0;
            top: 0;
            z-index: 3;
        }

        &__content {

            h6 {
                color: ${props => props.color || '#FFF'};
                font-size: 1.25rem; /* 20px converted to rem */
                font-style: normal;
                font-weight: 500;
                line-height: 1.75rem; /* 28px converted to rem */
                transition: ${theme.transition};
                @media (min-width: 1336px) {
                    width: 69%;
                }
            }
        }

        &__count {
            margin-top: 15px;
            margin-bottom: 15px;


            svg {
                width: 30px;

                path {
                    transition: ${theme.transition};

                    stroke: ${props => props.color || '#FFF'};
                }
            }

            p {
                transition: ${theme.transition};

                display: flex;
                align-items: center;
                gap: 15px;
                color: ${props => props.color || '#FFF'};
                font-size: 1rem; /* 16px converted to rem */
                font-style: normal;
                font-weight: 500;
                line-height: 1.5rem; /* 24px converted to rem */
            }
        }

        &:hover {
            .global-image-image {
                img {
                    transform: scale(1.04);
                }
            }

            h6 {
                color: ${props => props.hover || theme.colors.hover} !important;
            }

            svg {
                path {
                    stroke: ${props => props.hover || theme.colors.hover} !important;
                }
            }

            p {
                color: ${props => props.hover || theme.colors.hover} !important;
            }
        }

    }




`;
export default CaseStudySingle;
